/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Seat/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Confirmation from './Confirmation/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Seat({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/Action/Seat"
  
}) {
let appointmentBookingDisabledValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'disabled',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 size="small"
 onClick={onClick}
 data="appointment_booking.disabled"
 disabled={appointmentBookingDisabledValueData}
 text="Seat"
/>
<Confirmation
  viewPath={`${viewPath}/Confirmation`}
/>
{children}
</React.Fragment>)
}